// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.up-grid-layout {
  width: 1300px;
  height: 1000vh;
  margin-top: 0px;
  margin-left: -15px;  
  display: flex;
  flex-direction: column;
  background: gray;
}

.up-header-container {
  width: 1230px;
  height: 240px;
  max-height: 95%;
  max-width: 100%;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  /* background: lightgray;     */
  overflow-y: auto;
  /* margin-top: 50px;
  margin-left: 100px; */    
}

.up-post-container {
  width: 1000%;
  height: 1000px;
  max-height: 95%;
  max-width: 100%;
  padding: 15px;
  /* border: 1px solid #ddd; */
  border-radius: 8px;
  /* background: lightgray;     */
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  /* margin-top: 50px;
  margin-left: 100px; */
}

.up-create-post-container {
  width: 1230px;
  height: 300px;
  overflow-y: auto;
  display: flex;
  flex-direction: row;
}

.up-description-input {
  height: 100%;
  width: 60%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: none;
  overflow-y: auto;
  margin-left: 40px;
}

.up-submission-container {
  /* margin-top: 20px; */
  /* margin-left: 9px; */
  height: 100%;
  width: 30%;
  display: flex;
  flex-direction: column;
  /* max-width: 1000px;
  max-height: 1000vh; */
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}

.up-media-section {
  /* margin-top: 60px;
  margin-bottom: 0px; */
  width: 30%;
  /* margin-left: 200px; */
  height: 30px;
  /* align-items: center; */
  gap: 10px;
  background: black;
  display: flex;
  flex-direction: column;
}

.up-upload-btn {
  padding: 8px 12px;
  width: 100px;
  height: 40px;
  align-items: center;
  margin-top: -5px;
  font-weight: bold;
  background: rgb(34, 31, 31);
  margin-left: 10px;
  color: white;
  cursor: pointer;
  border-radius: 10px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; 
  font-size: 16px;
}

.up-post-btn {
  padding: 8px 12px;
  width: 100px;
  height: 40px;
  align-items: center;
  font-weight: bold;
  font-family: puppins;
  background: rgb(34, 31, 31);
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 10px;
  margin-top: 10px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; 
  font-size: 16px;
}

.up-upload-btn:hover, .up-post-btn:hover {
  background: #0056b3;
}

.up-uploaded-media {
  margin-top: 10px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; 
  font-size: 16px;
  color: white;
}

.up-media-preview {
  display: inline-block;
  padding: 5px;
  margin: 3px;
  background: black;
  color: white;
  border-radius: 4px;
}

.up-remove-btn {
  padding: 8px 12px;
  width: 100px;
  height: 40px;
  align-items: left;
  font-family: puppins;
  background: rgb(34, 31, 31);
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 10px;
  cursor: not-allowed; /* Show disabled cursor */
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; 
  font-size: 16px;
  opacity: 0.6;
  margin-top: 20px;
  font-weight: bold;
}

.up-remove-btn:not(:disabled) {
  background-color: darkgray;
  color: black;
  cursor: pointer;
  opacity: 1;
  font-weight: bold;
}

.up-post-lower-segment {
width: 100%;
max-height: 1000vh;
height: 400px;
display: flex;
flex-direction: column;
border-radius: 20px;
}

.up-post-header-segment {
width: 100%;
height: 50px;
border-radius: 20px;
}

.up-post-feed-segment {
width: 100%;
height: 200px;
border-radius: 20px;
}

.up-toggle-switch {
position: relative;
display: inline-block;
width: 50px;
height: 26px;
}

.up-toggle-switch input {
opacity: 0;
width: 0;
height: 0;
}

.up-toggle-slider {
position: absolute;
cursor: pointer;
top: 0;
left: 0;
right: 0;
bottom: 0;
background-color: red;
transition: 0.4s;
border-radius: 30px;
}

.up-toggle-slider:before {
position: absolute;
content: "";
height: 20px;
width: 20px;
left: 4px;
bottom: 3px;
background-color: white;
transition: 0.4s;
border-radius: 50%;
}

.up-toggle-switch input:checked + .up-toggle-slider {
background-color: green;
}

.up-toggle-switch input:checked + .up-toggle-slider:before {
transform: translateX(24px);
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/OverlayPage/Styles/Post.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB;uBACqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB;uBACqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EAEE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB;uBACqB;EACrB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE;uBACqB;EACrB,UAAU;EACV,wBAAwB;EACxB,YAAY;EAEZ,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mJAAmJ;EACnJ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EAEpB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mJAAmJ;EACnJ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mJAAmJ;EACnJ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EAEpB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB,EAAE,yBAAyB;EAC9C,mJAAmJ;EACnJ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;AACA,WAAW;AACX,kBAAkB;AAClB,aAAa;AACb,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB;;AAEA;AACA,WAAW;AACX,YAAY;AACZ,mBAAmB;AACnB;;AAEA;AACA,WAAW;AACX,aAAa;AACb,mBAAmB;AACnB;;AAEA;AACA,kBAAkB;AAClB,qBAAqB;AACrB,WAAW;AACX,YAAY;AACZ;;AAEA;AACA,UAAU;AACV,QAAQ;AACR,SAAS;AACT;;AAEA;AACA,kBAAkB;AAClB,eAAe;AACf,MAAM;AACN,OAAO;AACP,QAAQ;AACR,SAAS;AACT,qBAAqB;AACrB,gBAAgB;AAChB,mBAAmB;AACnB;;AAEA;AACA,kBAAkB;AAClB,WAAW;AACX,YAAY;AACZ,WAAW;AACX,SAAS;AACT,WAAW;AACX,uBAAuB;AACvB,gBAAgB;AAChB,kBAAkB;AAClB;;AAEA;AACA,uBAAuB;AACvB;;AAEA;AACA,2BAA2B;AAC3B","sourcesContent":[".up-grid-layout {\n  width: 1300px;\n  height: 1000vh;\n  margin-top: 0px;\n  margin-left: -15px;  \n  display: flex;\n  flex-direction: column;\n  background: gray;\n}\n\n.up-header-container {\n  width: 1230px;\n  height: 240px;\n  max-height: 95%;\n  max-width: 100%;\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  /* background: lightgray;     */\n  overflow-y: auto;\n  /* margin-top: 50px;\n  margin-left: 100px; */    \n}\n\n.up-post-container {\n  width: 1000%;\n  height: 1000px;\n  max-height: 95%;\n  max-width: 100%;\n  padding: 15px;\n  /* border: 1px solid #ddd; */\n  border-radius: 8px;\n  /* background: lightgray;     */\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  /* margin-top: 50px;\n  margin-left: 100px; */\n}\n\n.up-create-post-container {\n  width: 1230px;\n  height: 300px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: row;\n}\n\n.up-description-input {\n  margin-left: 10px;\n  height: 100%;\n  width: 60%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  resize: none;\n  overflow-y: auto;\n  margin-left: 40px;\n}\n\n.up-submission-container {\n  /* margin-top: 20px; */\n  /* margin-left: 9px; */\n  height: 100%;\n  width: 30%;\n  display: flex;\n  flex-direction: column;\n  /* max-width: 1000px;\n  max-height: 1000vh; */\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  overflow-y: auto;\n}\n\n.up-media-section {\n  /* margin-top: 60px;\n  margin-bottom: 0px; */\n  width: 30%;\n  /* margin-left: 200px; */\n  height: 30px;\n  display: flex;\n  /* align-items: center; */\n  gap: 10px;\n  background: black;\n  display: flex;\n  flex-direction: column;\n}\n\n.up-upload-btn {\n  padding: 8px 12px;\n  width: 100px;\n  height: 40px;\n  align-items: center;\n  margin-top: -5px;\n  font-weight: bold;\n  background: rgb(34, 31, 31);\n  margin-left: 10px;\n  color: white;\n  cursor: pointer;\n  border-radius: 10px;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; \n  font-size: 16px;\n}\n\n.up-post-btn {\n  padding: 8px 12px;\n  width: 100px;\n  height: 40px;\n  align-items: center;\n  font-weight: bold;\n  font-family: puppins;\n  font-size: 12px;\n  background: rgb(34, 31, 31);\n  color: white;\n  border: none;\n  cursor: pointer;\n  border-radius: 10px;\n  margin-top: 10px;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; \n  font-size: 16px;\n}\n\n.up-upload-btn:hover, .up-post-btn:hover {\n  background: #0056b3;\n}\n\n.up-uploaded-media {\n  margin-top: 10px;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; \n  font-size: 16px;\n  color: white;\n}\n\n.up-media-preview {\n  display: inline-block;\n  padding: 5px;\n  margin: 3px;\n  background: black;\n  color: white;\n  border-radius: 4px;\n}\n\n.up-remove-btn {\n  padding: 8px 12px;\n  width: 100px;\n  height: 40px;\n  align-items: left;\n  font-family: puppins;\n  font-size: 12px;\n  background: rgb(34, 31, 31);\n  color: white;\n  border: none;\n  cursor: pointer;\n  border-radius: 10px;\n  cursor: not-allowed; /* Show disabled cursor */\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; \n  font-size: 16px;\n  opacity: 0.6;\n  margin-top: 20px;\n  font-weight: bold;\n}\n\n.up-remove-btn:not(:disabled) {\n  background-color: darkgray;\n  color: black;\n  cursor: pointer;\n  opacity: 1;\n  font-weight: bold;\n}\n\n.up-post-lower-segment {\nwidth: 100%;\nmax-height: 1000vh;\nheight: 400px;\ndisplay: flex;\nflex-direction: column;\nborder-radius: 20px;\n}\n\n.up-post-header-segment {\nwidth: 100%;\nheight: 50px;\nborder-radius: 20px;\n}\n\n.up-post-feed-segment {\nwidth: 100%;\nheight: 200px;\nborder-radius: 20px;\n}\n\n.up-toggle-switch {\nposition: relative;\ndisplay: inline-block;\nwidth: 50px;\nheight: 26px;\n}\n\n.up-toggle-switch input {\nopacity: 0;\nwidth: 0;\nheight: 0;\n}\n\n.up-toggle-slider {\nposition: absolute;\ncursor: pointer;\ntop: 0;\nleft: 0;\nright: 0;\nbottom: 0;\nbackground-color: red;\ntransition: 0.4s;\nborder-radius: 30px;\n}\n\n.up-toggle-slider:before {\nposition: absolute;\ncontent: \"\";\nheight: 20px;\nwidth: 20px;\nleft: 4px;\nbottom: 3px;\nbackground-color: white;\ntransition: 0.4s;\nborder-radius: 50%;\n}\n\n.up-toggle-switch input:checked + .up-toggle-slider {\nbackground-color: green;\n}\n\n.up-toggle-switch input:checked + .up-toggle-slider:before {\ntransform: translateX(24px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
